import { useEffect, useMemo, useState } from 'react';

import type { ShareFeedItem } from 'src/app/pages/psf/share/pageContext';

type Result = ModelHookResult<{
	items: readonly ShareFeedItem[];
	animateSpeed: number;
	animateDelay: number;
}>;

const ANIMATE_DELAY = 2000;
const ANIMATE_SPEED = 300;

export function useShareFeed(shareFeed: readonly ShareFeedItem[], animationStartSize: number): Result {
	const [items, setItems] = useState<readonly ShareFeedItem[]>([...shareFeed].reverse().slice(0, animationStartSize));

	useEffect(() => {
		if (items.length >= shareFeed.length) {
			return undefined;
		}

		const timeout = window.setTimeout(() => {
			setItems([...shareFeed].reverse().slice(0, items.length + 1));
		}, ANIMATE_DELAY + ANIMATE_SPEED);
		return () => {
			window.clearTimeout(timeout);
		};
	}, [items, shareFeed]);

	return {
		data: {
			items: useMemo(() => [...items].reverse(), [items]),
			animateSpeed: ANIMATE_SPEED,
			animateDelay: ANIMATE_DELAY,
		},
	};
}
